/**
 * Shared helper for determining whether a refresh token value is actually
 * usable to call the refresh endpoint.
 *
 * A refresh token is "usable" only when it is a non-empty string and is not
 * the legacy `'not-available'` sentinel that older auto-login flows persisted
 * when no real refresh token was issued.
 *
 * Centralized here so the rule lives in exactly one place — drift between
 * `auth/session.js`, `auth/tokenManager.js`, and `api/tokenAuth.js` would
 * silently re-introduce the LESSEEPORT-1575 bug class.
 */
export const hasUsableRefreshToken = (refreshToken) => (
  typeof refreshToken === 'string' &&
  refreshToken.trim().length > 0 &&
  refreshToken !== 'not-available'
);
